import api from '..'

interface LmsProfilesListParams {
  page: number
  searchText: string
  sort: any[]
  perPage?: number
  excludeIds?: Array<number | string>
}

const lmsProfilesList = ({
  page,
  searchText,
  sort,
  perPage,
  excludeIds = [],
}: LmsProfilesListParams) => {
  const order = sort.map(({ key, order }) => `${key} ${order}`).join(', ')

  return api
    .get('administration/lms_profiles', {
      params: {
        page,
        search: searchText,
        order,
        ...(perPage ? { per_page: perPage } : {}),
        ...(excludeIds.length
          ? { exclude_ids: excludeIds.map(String).join(',') }
          : {}),
      },
    })
    .then(({ data, headers }) => {
      return {
        data: data.data.map(({ attributes }: any) => attributes),
        total: parseInt(headers['total'], 10),
        perPage: parseInt(headers['per-page'], 10),
      }
    })
}

export default lmsProfilesList
